/**
 * config.js — Legacy import stubs — JWT session.
 * Provides null stubs so any remaining import { auth, firestore, ... } from '../firebase/config'
 * continues to compile without the firebase npm package.
 *
 * auth.currentUser is backed by the in-memory JWT session stored in jwtAuth.
 */
import { getUser } from '../auth/jwtAuth';

// Minimal auth shim — only .currentUser is used by legacy callers.
export const auth = {
    get currentUser() {
        return getUser();
    },
};

// Unused stubs kept so destructure imports don't break.
export const firestore = null;
export const functions = null;
export const storage = null;
export const database = null;
